import { QueryRef } from "apollo-angular";
import { Observable } from "rxjs";
import { Subscription } from "rxjs";

export abstract class ListServiceBase {
  private result = null;
  private counter = 0;

  getSubscription(subscriber): Subscription {
    return this.result.subscribe(
      (data) => {
        subscriber.next(data);
      },
      (error) => {
        subscriber.error(error);
      },
      () => {
        subscriber.complete();
      }
    );
  }

  getList(variables = null): Observable<any> {
    const that = this;
    return Observable.create((subscriber) => {
      that.counter++;
      if (that.result === null) {
        that.result = that.getQuery(variables);
      }
      const subscriptionToResult = that.getSubscription(subscriber);
      return () => {
        that.counter--;
        subscriptionToResult.unsubscribe();
        if (this.counter === 0) {
          that.result = null;
        }
      };
    });
  }

  abstract getQuery(variables): QueryRef<any>;
}
